import React, { useState } from 'react';
import { BsPersonPlusFill } from 'react-icons/bs';
import { MdOutlinePlaylistAddCheck } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

type IPropsButtonAddEgressos = {
  item: any
  disable?:boolean
}

export function ButtonHistoryFigma({ item, disable }:IPropsButtonAddEgressos) {
  const [egressosColor, setEgressosColor] = useState(false);
  function handleSetEgressosColor() {
    setEgressosColor(!egressosColor);
  }

  const history = useHistory();

  function handleHistory() {
    history.push({ state: item, pathname: '/cadastrar-ronda/historico-ronda' });
  }

  return (

    <Wrapper
      id={`egressos${item.id}`}
      data-tip="Histórico da Ronda"
      onClick={disable ? undefined : handleHistory}
    >
      <MdOutlinePlaylistAddCheck
        size={26}
        cursor={disable ? undefined : "pointer"}
        color={egressosColor ? "#005cbe" : undefined}
        // onMouseOver={disable ? undefined : handleSetEgressosColor}
        // onMouseOut={disable ? undefined : handleSetEgressosColor}
        className="icon"
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  font-size: 20px;
  @media (max-width: 1024px) {
    font-size: 15px;
  }
`;
